import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './PostPlatformPreview.scss';

var _ = require('lodash');

var moment = require('moment');

var URL = require('url-parse');

var FBPreview = /*#__PURE__*/function (_Component) {
  _inherits(FBPreview, _Component);

  var _super = _createSuper(FBPreview);

  function FBPreview() {
    var _this;

    _classCallCheck(this, FBPreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderFacebookPreview", function () {
      var message = _this.props.message && _this.props.message.replace(/\s+/g, '') ? /*#__PURE__*/React.createElement("p", {
        className: styles.fb_post_p
      }, _this.props.message) : /*#__PURE__*/React.createElement("p", {
        className: styles.fb_post_p
      }, /*#__PURE__*/React.createElement("i", null, "Type a message to see the preview here."));
      var accountInfo = {
        profileImage: 'https://likeabucket.s3.amazonaws.com/jpcauinbxa_1467044403579.jpg',
        profileName: 'Username'
      };

      if (_this.props.account) {
        accountInfo.profileImage = _this.props.account.avatarImageUrl;
        accountInfo.profileName = _this.props.account.username;
      }

      if (!_this.props.link) {
        var imgList = _this.props.images;
        var videoList = [];

        if (_this.props.videos && _this.props.videos.length > 0) {
          imgList = [];
          videoList = _this.props.videos;
        }

        var imgTags = imgList.map(function (url, idx) {
          var styleObj = {
            backgroundImage: "url(".concat(url, ")"),
            backgroundPosition: 'center center',
            paddingBottom: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            display: 'inline-block',
            width: '100%'
          };
          var classColSize = 12;

          if (imgList.length === 4) {
            classColSize = 6;
            styleObj.paddingBottom = '50%';
          } else if (imgList.length === 2) {
            classColSize = 12;
            styleObj.paddingBottom = '50%';
          } else if (imgList.length === 3) {
            if (idx === 0 || idx === 1) {
              classColSize = 6;
            } else {
              classColSize = 12;
            }

            styleObj.paddingBottom = '50%';
          }

          return /*#__PURE__*/React.createElement("div", {
            key: idx,
            className: "col-xs-".concat(classColSize),
            style: styleObj
          });
        });
        var videoTags = videoList.map(function (url, idx) {
          return /*#__PURE__*/React.createElement("video", {
            key: idx,
            style: {
              width: '100%',
              height: '100%'
            },
            autoPlay: true,
            loop: true,
            controls: true,
            muted: true
          }, /*#__PURE__*/React.createElement("source", {
            src: url,
            type: "video/".concat(url.split('.').pop())
          }), "Your browser does not support the video tag.");
        });
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: styles.facebook_preview
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.fb_profile
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.profile_img,
          src: accountInfo.profileImage
        }), /*#__PURE__*/React.createElement("h3", {
          className: styles.name
        }, accountInfo.profileName), /*#__PURE__*/React.createElement("small", {
          className: styles.fb_profile_small
        }, _this.props.postDate ? _this.props.postDate.format('MM/DD/YYYY, h:mm a') : '')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
          className: styles.fb_post
        }, message, /*#__PURE__*/React.createElement("div", {
          className: styles.img_container
        }, imgTags, videoTags))), /*#__PURE__*/React.createElement("div", {
          className: styles.fb_actions
        }, /*#__PURE__*/React.createElement("img", {
          style: {
            width: '100%'
          },
          src: "https://s3.amazonaws.com/likeabucket/user_upload/232/8HeADTcW.jpeg"
        })));
      }

      var imgContainer = _this.props.images && _this.props.images.length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: "url(".concat(_this.props.images[0], ")"),
          paddingBottom: '50%',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          borderBottom: '1px solid #DBDBDB'
        }
      }) : null;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.facebook_preview
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.fb_profile
      }, /*#__PURE__*/React.createElement("img", {
        className: styles.profile_img,
        src: accountInfo.profileImage
      }), /*#__PURE__*/React.createElement("h3", {
        className: styles.name
      }, accountInfo.profileName), /*#__PURE__*/React.createElement("small", {
        className: styles.fb_profile_small
      }, _this.props.postDate ? _this.props.postDate.format('MM/DD/YYYY, h:mm a') : '')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
        className: styles.fb_post
      }, message, /*#__PURE__*/React.createElement("div", {
        className: styles.img_container
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          border: '1px solid #DBDBDB',
          textAlign: 'left'
        }
      }, imgContainer, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '5px'
        }
      }, /*#__PURE__*/React.createElement("h4", {
        style: {
          fontSize: '1.3em',
          fontFamily: 'Times New Roman',
          marginTop: 10,
          marginBottom: 0
        }
      }, _this.props.linkTitle), /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: '0.8em'
        }
      }, _this.props.linkDescription), /*#__PURE__*/React.createElement("small", {
        style: {
          color: '#a6a6a6',
          fontSize: '0.7em'
        }
      }, _this.props.linkCaption ? _this.props.linkCaption.toUpperCase() : '')))))), /*#__PURE__*/React.createElement("div", {
        className: styles.fb_actions
      }, /*#__PURE__*/React.createElement("img", {
        src: "https://s3.amazonaws.com/likeabucket/user_upload/232/8HeADTcW.jpeg"
      })));
    });

    return _this;
  }

  _createClass(FBPreview, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.renderFacebookPreview());
    }
  }]);

  return FBPreview;
}(Component);

_defineProperty(FBPreview, "propTypes", {});

_defineProperty(FBPreview, "defaultProps", {
  message: 'Your message',
  account: {
    avatarImageUrl: '',
    username: 'Your username'
  },
  images: [],
  videos: [],
  postDate: '',
  link: '',
  linkTitle: '',
  linkDescription: '',
  linkCation: ''
});

export { FBPreview as default };